import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-bonificacion',
  templateUrl: './btn-nuevo-bonificacion.component.html',
  styleUrls: ['./btn-nuevo-bonificacion.component.css']
})
export class BtnNuevoBonificacionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
